import React from "react";
import { Input, Label, FormFeedback } from "reactstrap";

interface InputFormProps {
  label: string;
  name: string;
  value: string;
  type: string;
  touched: any;
  errors: any;
  options?: any;
  placeholder?: string;
  readonly?: boolean;
  disabled?: boolean;
  onChange?: (e: any) => void;
  onBlur?: (e: any) => void;
}

const InputForm: React.FC<InputFormProps> = (props: InputFormProps) => {
  const {
    label,
    name,
    value,
    type,
    touched,
    errors,
    options,
    placeholder,
    onChange,
    onBlur,
    readonly,
    disabled,
  } = props;
  return (
    <>
      {label && <Label className="form-label">{label}</Label>}

      {type === "select" && (
        <Input
          type="select"
          name={name}
          onChange={onChange}
          onBlur={onBlur}
          value={value || ""}
          invalid={touched && errors ? true : false}
          disabled={disabled}
        >
          {!options.some(
            (item: { value: string; label: string }) =>
              item.value === "486" || item.label === "SELECCIONE"
          ) && <option value="">SELECCIONE</option>}

          {options.length > 0 &&
            options.map((item: any) => (
              <option key={item.value} value={item.value}>
                {item.label}
              </option>
            ))}
        </Input>
      )}

      {(type === "text" ||
        type === "password" ||
        type === "email" ||
        type === "file") && (
        <Input
          name={name}
          type={type}
          onChange={onChange}
          onBlur={onBlur}
          value={value || ""}
          invalid={touched && errors ? true : false}
          placeholder={placeholder}
          readOnly={readonly}
          disabled={disabled}
        />
      )}

      {touched && errors ? (
        <FormFeedback type="invalid">{errors}</FormFeedback>
      ) : null}
    </>
  );
};

export default InputForm;
